import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-10 max-w-2xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20cinematic%20film%20strip%20with%20dramatic%20grainy%20texture%2C%20warm%20golden%20and%20amber%20tones%2C%20abstract%20entertainment%20media%20concept%2C%20vintage%20cinema%20aesthetic%20with%20modern%20twist%2C%20dark%20background%20with%20glowing%20highlights%2C%20editorial%20photography&width=1200&height=600&seq=chigua-cta-film&orientation=landscape"
              alt="吃瓜视频 - 不错过任何一个大瓜"
              title="吃瓜视频每日更新"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-black/40"></div>
          </div>
        </div>

        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4 leading-relaxed">
          不错过<span className="italic text-primary-600 mx-1">任何一个</span>大瓜
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8">
          每日更新 · 实时追踪 · 高清流畅
        </p>

        <Link
          to="/category/remen"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 hover:bg-foreground-800 text-white font-medium text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          立即开始吃瓜
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}